import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import '../css/App.css';
import Cabecera from './Cabecera';
import MenuNav from './MenuNav';
import Presentacion from './Presentacion';
import FormacionAcademica from './FormacionAcademica';
import ExperienciaLaboral from './ExperienciaLaboral';
import Referencias from './Referencias';
import OtrosDatosInteres from './OtrosDatosInteres';
import Documentos from './Documentos';
import Footer from './Footer';


class App extends React.Component {
  render(): React.ReactNode {
    return (
      <div id="ContainerApp">
        <Cabecera />
        <HashRouter>
          <MenuNav />
          <Routes>
            <Route path="/presentacion" element={<Presentacion />} />
            <Route path="/formacionAcademica" element={<FormacionAcademica />} />
            <Route path="/experienciaLaboral" element={<ExperienciaLaboral />} />
            <Route path="/referencias" element={<Referencias />} />
            <Route path="/otrosDatos" element={<OtrosDatosInteres />} />
            <Route path="/documentos" element={<Documentos />} />
            <Route path="#Contacto" />
          </Routes>
        </HashRouter>
        <Footer />
      </div>
    );
  }
}

export default App;